import { render, staticRenderFns } from "./NavigationUser.vue?vue&type=template&id=04cdd768&"
import script from "./NavigationUser.vue?vue&type=script&lang=ts&"
export * from "./NavigationUser.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationUser.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports